module.exports = __webpack_public_path__ + "static/diy_recipe_koala_cookies-a8c110383e804940bf7a500096440f81.pdf";